const articlesToMigrate = require('./articlesToMigrate.json')

function articleUrl(article) {
  if(articlesToMigrate.some(obj=>obj.from === article?.slug)){
    return `/${articlesToMigrate.find(obj=>obj.from === article?.slug).to}`
  }
    if (article?.shortUrl) {
      return `/${article?.slug}`
    }
    return `/${article?.slug}`
  }


  
  module.exports = (article, site) => {
    return articleUrl(article, site)
  }
  